import type { KnownDomainSlugs } from 'bundles/browse-common/types/domain';

const knownDomainSlugs = [
  'arts-and-humanities',
  'business',
  'computer-science',
  'data-science',
  'health',
  'information-technology',
  'language-learning',
  'math-and-logic',
  'personal-development',
  'physical-science-and-engineering',
  'social-sciences',
] satisfies KnownDomainSlugs[];

export function isKnownDomainSlug(slug?: string): slug is KnownDomainSlugs {
  return knownDomainSlugs.includes(slug ?? '');
}
